import * as $ from "jquery";
import {_} from 'lodash';
import {_d} from "./util/misc";

interface IEventObject {
    target: any;
    events: string;
    args: any[];
}

class PubSub {

    private obj = jQuery({});
    private subscriptions: Array<IEventObject> = [];

    on(target: any, ...args: any[]) {
        if (_.isString(target)) {
            _d.error("Cannot set target to type String");
            return;
        }
        let events = args[0];
        (this.obj.on as (...handlerArgs: any[]) => JQuery<any>).apply(this.obj, args);
        this.subscriptions.push({
            target: target,
            events: events,
            args: args
        });
    }

    off(target: any, events?: string) {
        if (events) {
            let index = this.findIndex(target, events);
            let item = this.subscriptions[index];
            if (item) {
                (this.obj.off as (...handlerArgs: any[]) => JQuery<any>).apply(this.obj, item.args);
                this.subscriptions.splice(index, 1);
            }
        } else {
            let items = this.filter(target);
            items.forEach((obj: IEventObject) => {
                this.off(obj.target, obj.events);
            });
        }
    }

    trigger(event: string, extraParams?: any) {
        if (extraParams !== undefined) {
            this.obj.trigger.call(this.obj, event, extraParams);
            return;
        } else {
            this.obj.trigger.call(this.obj, event);
        }
    }

    private findIndex(target: any, events: string) {
        return this.subscriptions.findIndex((obj: IEventObject) => {
            let isSameTarget = obj.target === target;
            let isSameEvents = obj.events == events;
            return isSameTarget && isSameEvents
        });
    }

    private filter(target: any) {
        return this.subscriptions.filter((obj: IEventObject) => {
            return obj.target === target;
        });
    }

}

let pubsub = new PubSub();
export default pubsub;
